import { useContext } from 'react'
import { useStoreWithEqualityFn } from 'zustand/traditional'

import { AppStoreContext } from '../providers/AppStore'
import type { AppState } from '../store/types'

export const useAppStoreSelector = <T>(
  selector: (state: AppState) => T,
  equalityFn?: (left: T, right: T) => boolean
): T => {
  const store = useContext(AppStoreContext)

  if (!store || !Object.keys(store).length) {
    throw new Error(
      "Unable to use 'useAppStoreSelector' outside of 'AppStoreProvider'"
    )
  }

  return useStoreWithEqualityFn(store, selector, equalityFn)
}
